import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'

export function request(config) {

  //创建axios实例
  const instance = axios.create({
    baseURL: "https://www.agougoubuy.cn",
    // baseURL: "http://www.agougoubuy.cn:8201",
    // baseURL: "http://127.0.0.1:8201",
    // baseURL: "http://192.168.2.100:8201",
    // baseURL: "http://192.168.2.164:8201",
    // baseURL: "http://47.101.141.146:8201",
    timeout: 10000
  })


  //axios拦截器
  instance.interceptors.request.use(config => {
    // console.log(config)
    //1.比如config中的一些信息不符合服务器要求
    //2.比如每次发送网络请求时,都希望在界面显示换一个请求图标
    //3.某些网络请求(比如登录(token)),必须携带一些特殊信息
    if (store.getters.token) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  }, err => {
    console.log(err)
  })

  //拦截白名单
  const whiteList = [
      "/agg-portal/ap/sso/getLang"
  ]
  //拦截响应
  instance.interceptors.response.use(response => {
    /**
     *code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    let error = response.data.message;
    //拦截白名单 （不刷新）
    let number = whiteList.indexOf(response.config.url)
    if(res.code !== 200){
      if(res.code === 401 && number == -1){
        store.dispatch('FedLogOut').then( () => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      }
      return Promise.reject(error)
    }else {
      return response.data
    }
  }, err => {
    console.log(err)
    return Promise.reject(err)
  })

  //发送真正的网路请求
  return instance(config)
}

export default {
  fetchGet (url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.get(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPost (url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.post(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPostQuery (url, params = {}) {
    return new Promise((resolve, reject) => {
      instance.post(url,{}, {params}).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
